import { Children, type ReactNode } from 'react';
import { isElement } from 'react-is';

import { Pan } from '../slots/chart-interactions/Pan.js';
import { Zoom } from '../slots/chart-interactions/Zoom.js';
import { ZoomX } from '../slots/chart-interactions/ZoomX.js';
import { type ChartInteractionsConfig } from '../types/interactions.js';

/**
 * Generate chart config based on slots
 * @param children - CharInteraction children
 * @returns ChartInteraction slot config
 */
export const iterateChartInteractionsSlots = (children: ReactNode) => {
  let interactions: ChartInteractionsConfig = {};

  Children.forEach(children, (childInteractions) => {
    if (isElement(childInteractions)) {
      switch (childInteractions.type) {
        /* eslint-disable-next-line @typescript-eslint/no-deprecated */
        case Zoom:
          interactions = { ...interactions, zoom: { enabled: true } };
          break;
        /* eslint-disable-next-line @typescript-eslint/no-deprecated */
        case ZoomX:
          interactions = { ...interactions, zoomX: { enabled: true } };
          break;
        /* eslint-disable-next-line @typescript-eslint/no-deprecated */
        case Pan:
          interactions = { ...interactions, pan: { enabled: true } };
          break;
      }
    }
  });

  return interactions;
};
